import { render, staticRenderFns } from "./BonusWebinarsList.vue?vue&type=template&id=99579c52&scoped=true&"
import script from "./BonusWebinarsList.vue?vue&type=script&lang=js&"
export * from "./BonusWebinarsList.vue?vue&type=script&lang=js&"
import style0 from "./BonusWebinarsList.vue?vue&type=style&index=0&id=99579c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99579c52",
  null
  
)

export default component.exports